import { useCallback, useEffect, useRef } from 'react';
import { FormInstance } from 'antd';
import { useWatch } from 'components/UI/Form';
import { usePrevious } from 'hooks/usePrevious';

type InitFormValues = {
  [key: string]: string | undefined;
};

export const useSetInitialValues = (
  form?: FormInstance,
  /*
   * TODO: functionality must be changed to support falling back to previous
   * value automatically
   */
  previous?: { fieldName: string; fieldFallback?: any }
) => {
  const fieldToWatch = useWatch(previous?.fieldName || '', form);
  const fieldPreviousValue = usePrevious(fieldToWatch);
  const fieldPreviousValueRef = useRef(fieldPreviousValue);

  useEffect(() => {
    fieldPreviousValueRef.current = fieldPreviousValue;
  }, [fieldPreviousValue]);

  const applyInitialValues = useCallback(
    (changedValue: string) => {
      if (!form) {
        return;
      }
      const initialValue: InitFormValues = {};
      if (previous?.fieldName) {
        initialValue[previous.fieldName] =
          fieldPreviousValueRef.current || previous.fieldFallback;
      } else {
        initialValue[changedValue] = undefined;
      }
      form.setFieldsValue(initialValue);
    },
    [previous?.fieldName, previous?.fieldFallback]
  );

  return { applyInitialValues };
};
